import request from "@/service";

/* 分页列表-wangyang */
export function getPageList(params) {
  return request({
    url: `/sys/pub/homepage/page`,
    method: "get",
    params
  });
}

/* 新增 */
export function pageAdd(data) {
  return request({
    url: `/sys/pub/homepage/save`,
    method: "post",
    data
  });
}

/* 修改 */
export function pageEdit(data) {
  return request({
    url: `/sys/pub/homepage/update`,
    method: "put",
    data
  });
}

// 获取详情
export function getPageInfo(data) {
  return request({
    url: `/sys/pub/homepage/info/${data}`,
    method: "get"
  });
}

/* 删除 */
export function pageDel(data) {
  return request({
    url: `/sys/pub/homepage/delete`,
    method: "DELETE",
    data
  });
}

/* 上下线-wangyang */
export function homepageOnline(data) {
  return request({
    url: `/sys/pub/homepage/online`,
    method: "put",
    data
  });
}